import React from 'react'
import Link from 'gatsby-link'
import { Grid, Image, List, Responsive } from 'semantic-ui-react'

import CMLogo from '../../assets/images/logo_closet_minimal_light_flattened.svg'

import '../../styles/semantic.css'
import '../../styles/site.scss'

const Header = () => (
  <Grid verticalAlign='middle' columns={2} style={{ margin: '16px' }}>
    <Grid.Column mobile={8} tablet={6} computer={4}>
      <Link to='/'>
        <Image src={CMLogo} style={{ maxHeight: '2.5rem', minHeight: '2.5rem' }} />
      </Link>
    </Grid.Column>
    <Grid.Column mobile={8} tablet={10} computer={12}>
      <List horizontal link size='large' floated='right'>
        <Responsive maxWidth={-1}>
          <List.Item disabled>
            <Link to='/blog/'>Blog</Link>
          </List.Item>
        </Responsive>
        <List.Item>
          <Link to='/contact/'>Keep in Touch</Link>
        </List.Item>
      </List>
    </Grid.Column>
  </Grid>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js